<template>
    <v-container max-width="100%" style="margin-top: 2%;">
        <template>
            <v-row justify="center">
                <v-dialog v-model="confirmDialog" persistent max-width="500">
                    <v-card>
                        <v-card-title class="headline">
                            <span style="color: #d60000">{{ $t('system.alert') }}</span>
                        </v-card-title>
                        <v-card-text>
                            <span style="color: #d60000">{{ this.mensagemdialog }}</span>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red accent-4" class="white--text" @click="confirmDialog = false">{{
                                $t('button.dismiss') }}</v-btn>
                            <v-btn v-if="showConfirmButton" color="red accent-4" class="white--text"
                                @click="deleteFromDatabase">{{ $t('button.confirm') }}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
        </template>
        <merus-data-table :headers="headers" :items="classificacoes" :loading="loadingtable"
            :default-multi-sort="defaultSort" :loading-text="$t('tripsClassifications.loading')" @update:displayedItems="displayedItemsForExport = $event"

 cod-tabela="CLASSIFICACOESVIAGENS" @update:headers="headers = $event">
            <template v-slot:toolbar>
                <CadastroToolbar :title="$t('tripsClassifications.title')" :token="token" :items="displayedItemsForExport !== null ? displayedItemsForExport : classificacoes" :csv-title="$t('tripsClassifications.title')"
                    :pdf-title="$t('tripsClassifications.title')" :pdf-headers="headers" :pdf-filename="$t('tripsClassifications.title')" hide-search>
                    <template v-slot:add v-if="canInsert">
                        <v-dialog v-model="dialog" max-width="80%">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" fab>
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </template>
                            <v-card>
                                <v-toolbar dark color="primary" ref="myToolbar">
                                    <v-btn icon dark @click="close">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                    <v-toolbar-title>{{ $tc('tripsClassifications.self', 1) }}</v-toolbar-title>
                                </v-toolbar>

                                <v-card-text>
                                    <v-container>
                                        <v-form ref="form" v-model="formValidado">
                                            <v-row>
                                                <v-col cols="12" sm="6" md="6">
                                                    <v-text-field v-model="editedItem.cod_classificacao" :label="$t('tripsClassifications.code')"
                                                        :rules="[(v) => !!v || $t('tripsClassifications.validation.codeRequired')]"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="6">
                                                    <v-text-field v-model="editedItem.descricao_classificacao" :label="$t('tripsClassifications.description')"
                                                        :rules="[(v) => !!v || $t('tripsClassifications.validation.descriptionRequired')]"></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-form>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn dark color="primary" @click="close">{{ $t('button.cancel') }}</v-btn>
                                    <v-btn dark color="primary" @click="save">{{ $t('button.save') }}</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </template>
                </CadastroToolbar>

            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" color="green" @click="editItem(item)"
                    :disabled="item.can_edit == 0 || !canEdit">mdi-pencil</v-icon>
                <v-icon small class="mr-2" color="red" @click="deleteItem(item)"
                    :disabled="item.can_delete == 0 || !canDelete">mdi-delete</v-icon>
            </template>
        </merus-data-table>
    </v-container>
</template>

<script>

import apiController from "@/utils/apiController";
import MerusDataTable from "./Tables/MerusDataTable.vue";
import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
import EventBus from "../utils/eventBus";
import translateDbField from "@/utils/translateDbField";


export default {
    components: {
        MerusDataTable,
        CadastroToolbar
    },
    data: () => ({
    headers: [],
        displayedItemsForExport: null,
        classificacoes: [],
        loadingtable: true,
        tipoAlerta: "success",
        showAlert: false,
        mensagemAlerta: "",
        confirmDialog: false,
        mensagemdialog: "",
        showConfirmButton: true,
        authDialog: false,
        formValidado: true,
        dialog: false,
        editedIndex: -1,
        editedItem: {
            id_classificacao: null,
            cod_classificacao: null,
            descricao_classificacao: null
        },
        deletedItem: {
            id_classificacao: null,
            cod_classificacao: null,
            descricao_classificacao: null
        },
        defaultItem: {
            id_classificacao: null,
            cod_classificacao: null,
            descricao_classificacao: null
        },
        recursos: [],
        canInsert: false,
        canEdit: false,
        canDelete: false,
    }),
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user"));
        this.token = sessionStorage.getItem("api");
        this.populaRecursos();
    },
    watch: {
        '$i18n.locale'() {
            this.initialize();
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
        }
    },
    methods: {

        populaRecursos() {
            const user = JSON.parse(sessionStorage.getItem("user"));
            if (user.is_superadmin === 1) {
                apiController.request(apiController.endpoints.getallRecursos, {
                    onSuccess: (response) => {
                        this.recursos = response.data;
                        this.canEdit = true;
                        this.canInsert = true;
                        this.canDelete = true;
                        this.initialize();
                    },
                });
            } else {
                apiController.request(apiController.endpoints.getRecursosusuario, {
                    params: { id: this.user.id_usuario },
                    onSuccess: (response) => {
                        this.recursos = response.data;
                        this.canEdit = this.recursos.some((r) => r.rota === "/api/v1.0/updateclassificacao");
                        this.canInsert = this.recursos.some((r) => r.rota === "/api/v1.0/insertclassificacao");
                        this.canDelete = this.recursos.some((r) => r.rota === "/api/v1.0/deleteclassificacao");
                        this.initialize();
                    },
                });
            }
        },
        initialize() {
            apiController.request(apiController.endpoints.getallClassificacoes, {
                silent: true,
                onSuccess: (response) => {
                    this.classificacoes = response.data;
                    this.classificacoes.forEach(classificacao => {
                        classificacao.descricao_classificacao = translateDbField(
                            classificacao.translation_key,
                            classificacao.descricao_classificacao
                        );
                        return classificacao;
                    });
                    this.loadingtable = false;
                },
                onError: (e) => {
                    console.log(e);
                    this.sysError = e;
                    this.authDialog = true;
                },
            });
        },
        close() {
            this.dialog = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.deletedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },
        editItem(item) {
            this.editedIndex = this.classificacoes.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.operacao = 1;
            this.dialog = true;
        },
        deleteItem(item) {
            this.deletedItem = Object.assign({}, item);
            this.operacao = 2;
            this.mensagemdialog = this.$t('tripsClassifications.deleteClassification') + ` ${this.deletedItem.descricao_classificacao}?`
            this.messageConfirmButton = this.$t('button.delete');
            this.messageDismissButton = this.$t('button.cancel');
            this.showConfirmButton = true;
            this.confirmDialog = true;
        },
        deleteFromDatabase() {
            apiController.request(apiController.endpoints.deleteClassificacao, {
                    data: this.deletedItem,
                    onSuccess: (response) => {
                        this.updateTable(response.data.erro);
                        this.confirmDialog = false;
                    },
                    onError: () => {
                        this.confirmDialog = false;
                    },
                });
            },
            save(){
                this.$refs.form.validate();
                if (this.formValidado) {
                    if (this.editedIndex == -1) {
                        this.operacao = 0;

                    apiController.request(apiController.endpoints.insertClassificacao, {
                        data: this.editedItem,
                        onSuccess: (response) => {
                            this.updateTable(response.data.erro);
                        },
                    });
                } else {
                    this.operacao = 1;
                    apiController.request(apiController.endpoints.updateClassificacao, {
                        data: this.editedItem,
                        onSuccess: (response) => {
                            this.updateTable(response.data.erro);
                        },
                    });
                }
            }
        },
        updateTable(status) {
                let mensagem = "";
                let tipo = status ? "error" : "success";
                
            if (status) {
                if (this.operacao == 0) {
                    mensagem = this.$t('tripsClassifications.alerts.error.insert');
                } else {
                    if (this.operacao == 1) {
                        mensagem = this.$t('tripsClassifications.alerts.error.update');
                    } else {
                        mensagem = this.$t('tripsClassifications.alerts.error.delete');
                    }
                    }
                } else {
                    if (this.operacao == 0) {
                    mensagem = this.$t('tripsClassifications.alerts.success.insert');
                    } else {
                    if (this.operacao == 1) {
                        mensagem = this.$t('tripsClassifications.alerts.success.update');
                    } else {
                        mensagem = this.$t('tripsClassifications.alerts.success.delete');
                    }
                    }
                }
                
                EventBus.$emit('show-alert', { mensagem, tipo });
                this.close();
                this.initialize();
            },
        },
    }
</script>